import { render, staticRenderFns } from "./hospitalChekedDetail.vue?vue&type=template&id=1124315c&scoped=true"
import script from "./hospitalChekedDetail.vue?vue&type=script&lang=js"
export * from "./hospitalChekedDetail.vue?vue&type=script&lang=js"
import style0 from "./hospitalChekedDetail.vue?vue&type=style&index=0&id=1124315c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1124315c",
  null
  
)

export default component.exports